var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarbonDelivery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "carbon:delivery-parcel"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.7687 6.42888L13.8937 2.64763C13.7921 2.59178 13.6782 2.5625 13.5623 2.5625C13.4464 2.5625 13.3324 2.59178 13.2309 2.64763L6.35591 6.42888C6.24812 6.48823 6.15823 6.57542 6.09563 6.68135C6.03303 6.78729 6 6.90808 6 7.03113C6 7.15418 6.03303 7.27498 6.09563 7.38091C6.15823 7.48684 6.24812 7.57403 6.35591 7.63338L12.8748 11.2187V18.588L10.7875 17.4399L10.1248 18.6437L13.2309 20.3521C13.3324 20.4081 13.4464 20.4375 13.5623 20.4375C13.6782 20.4375 13.7922 20.4081 13.8937 20.3521L20.7687 16.5709C20.8765 16.5116 20.9664 16.4244 21.0291 16.3184C21.0917 16.2125 21.1248 16.0917 21.1248 15.9686V7.03113C21.1248 6.90806 21.0917 6.78725 21.0291 6.68132C20.9664 6.57538 20.8765 6.4882 20.7687 6.42888ZM13.5623 4.03501L19.0107 7.03113L13.5623 10.0273L8.11385 7.03113L13.5623 4.03501ZM19.7498 15.5623L14.2498 18.5873V11.218L19.7498 8.19301V15.5623Z",
    fill: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.375 11.5H1.875V10.125H7.375V11.5ZM8.75 17H3.25V15.625H8.75V17ZM10.125 14.25H4.625V12.875H10.125V14.25Z",
    fill: "#555555"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonDelivery);
export default __webpack_public_path__ + "static/media/carbon_delivery.18151181a5d9f6e43e2b2e0b2d4e3aea.svg";
export { ForwardRef as ReactComponent };